import { finectAPI } from '@finect/front-utils/finectAPI';
import { models } from './models';
export var postReview = function postReview(productId, body) {
  return finectAPI({
    version: 'v4',
    path: "contents/products/".concat(productId, "/reviews"),
    method: 'POST',
    body: body,
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return models.review(data.review, [data.author]);
    },
    onError: function onError(_ref2) {
      var data = _ref2.data;
      return data;
    }
  });
};
export var patchReview = function patchReview(id, payload) {
  return finectAPI({
    version: 'v4',
    path: "contents/reviews/".concat(id),
    method: 'PATCH',
    body: payload,
    onSuccess: function onSuccess(_ref3) {
      var data = _ref3.data;
      return data;
    }
  });
};
export var deleteReview = function deleteReview(id) {
  return finectAPI({
    version: 'v4',
    path: "contents/reviews/".concat(id),
    method: 'DELETE',
    onSuccess: function onSuccess(_ref4) {
      var data = _ref4.data;
      return true;
    }
  });
};
export var likedReview = function likedReview(id) {
  return finectAPI({
    version: 'v4',
    path: "users/me/likes/reviews/".concat(id),
    method: 'GET',
    onSuccess: function onSuccess(_ref5) {
      var data = _ref5.data;
      return data.me === 'like';
    }
  });
};
export var likeReview = function likeReview(id) {
  return finectAPI({
    version: 'v4',
    path: "users/me/likes",
    method: 'POST',
    body: {
      type: 'review',
      id: id
    }
  });
};
export var unlikeReview = function unlikeReview(id) {
  return finectAPI({
    version: 'v4',
    path: "users/me/likes?type=review&id=".concat(id),
    method: 'DELETE'
  });
};
export var getFeatures = function getFeatures() {
  return finectAPI({
    version: 'v4',
    path: "contents/catalog/features",
    method: 'GET',
    onSuccess: function onSuccess(_ref6) {
      var data = _ref6.data;
      return models.reviewFeatures(data);
    },
    onError: function onError() {
      return [];
    }
  });
};